/**
 * Session-scoped cache for GET /api/v1/bsp/voice (aggregate, no app_id).
 * At most one in-flight / completed fetch per browser tab until reload.
 */

import VoiceCallsApiClient from './api/VoiceCallsApiClient';

/** @type {Promise<unknown>|null} */
let inFlight = null;

/** @type {unknown|null} */
let cachedPayload = null;

/**
 * @returns {Promise<unknown>}
 */
export function getOrFetchSipStatus() {
  if (cachedPayload != null) {
    return Promise.resolve(cachedPayload);
  }

  if (inFlight) {
    return inFlight;
  }

  inFlight = VoiceCallsApiClient.fetchSipStatus({})
    .then((payload) => {
      cachedPayload = payload;
      return payload;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

/**
 * Synchronous read when already resolved (no network).
 * @returns {unknown|null}
 */
export function peekSipStatusCache() {
  return cachedPayload;
}

/**
 * Clears the cached/in-flight SIP status so the next consumer refetches.
 * Use on session change and after any action that changes SIP registration state.
 */
export function invalidateSipStatusCache() {
  cachedPayload = null;
  inFlight = null;
}

/**
 * Test helper — clears module cache between specs.
 */
export function resetSipStatusCacheForTests() {
  invalidateSipStatusCache();
}
